import { createFileRoute, Link } from '@tanstack/react-router';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LoadingCard from '@/lib/loading/components/LoadingCard';
import useTeams from '@/lib/teams/hooks/useTeams';
import { getImageUrl } from '@/lib/constants';
import { Button } from '@heroui/react';
import { useAuth } from '@/lib/auth/hooks/useAuth';
import { useMemo, useState } from 'react';
import { Tier } from '@/lib/models/user';
import AddTeamModal from '@/components/account/teams/AddTeamModal';

export const Route = createFileRoute('/account/teams/')({
    component: RouteComponent,
});

function RouteComponent() {
    const { teams, isLoading } = useTeams();
    const [addTeam, setAddTeam] = useState(false);

    const { user } = useAuth();

    const canAddNewTeam = useMemo(() => {
        if (!user || !user.subscription_plan) return false;

        return (
            user.subscription_plan.active &&
            [Tier.ADVANCED_TEAM, Tier.BASIC_TEAM, Tier.MASTER_TEAM].includes(user.subscription_plan.tier) &&
            teams?.length < user.subscription_plan.team_limit
        );
    }, [teams?.length, user]);

    const toggleAddTeam = () => setAddTeam(x => !x);

    return (
        <div className='mx-auto  max-w-xl p-2'>
            <div className='flex flex-row items-center  justify-between pb-2'>
                <div className='flex-initial text-lg font-semibold'>My Teams</div>
                {canAddNewTeam && (
                    <Button onPress={toggleAddTeam} color='primary'>
                        Add Team
                    </Button>
                )}
            </div>
            <div className='simple-card grid w-full gap-y-4 p-3'>
                {isLoading ? (
                    <LoadingCard count={2} />
                ) : (
                    <>
                        {teams?.map(team => (
                            <Link
                                key={team.id}
                                to='/account/teams/$teamId'
                                params={{ teamId: team.id.toString() }}>
                                <div className='flex flex-row items-center justify-between rounded-sm p-4 hover:bg-gray-50'>
                                    <div className='flex flex-row items-center '>
                                        <div className='w-12 pr-3'>
                                            {!!team.logo && (
                                                <img src={getImageUrl(team.logo)} alt='team-logo' />
                                            )}
                                        </div>
                                        <div>
                                            <div className='font-semibold'>{team.name}</div>
                                            <div className='text-sm italic'>{team.users.length} users</div>
                                        </div>
                                    </div>
                                    <FontAwesomeIcon icon={faArrowRight} />
                                </div>
                            </Link>
                        ))}
                    </>
                )}
                {!isLoading && teams?.length === 0 && (
                    <span className='italic'>{"You don't have any teams"}</span>
                )}
            </div>
            {addTeam && <AddTeamModal toggleModal={toggleAddTeam} />}
        </div>
    );
}
